import React, {useRef, useState, forwardRef, useImperativeHandle} from 'react';
import "./TextBox.css"
import {removeNekudot} from "./nekudot"


const TextBox = forwardRef((props, ref) => {

    const text = useRef(null);
    const phonetic = useRef(null);
    const info = useRef(null);
    const language = useRef('french');
    const [show, setShow] = useState(null); // combination of 'info', 'phonetic', 'vowels'

    const isTextVisible = () => {return show !== null;}
    const isPhoneticVisible = () => {return phonetic.current && show?.includes("phonetic")};
    const isInfoVisible = () => {return info.current && show?.includes("info");}
    const isVowelsVisible = () => {return show?.includes("vowels");}

    // Manage color
    const colorText = useRef(false);
    const colorVowels = useRef(false);
    const colorInfo = useRef(false);
    const colorPhonetic = useRef(false);

    const setShowHandle = (list) => {

        colorInfo.current = false;
        colorPhonetic.current = false;
        colorText.current = false;

        if (list === null) {
            setShow(null);
            return;
        }
        const list1 = list.map(l => {

            if (l === "*") {
                colorText.current = true;
                return null;
            }
            if (l === "*phonetic") {
                colorPhonetic.current = true;
                return "phonetic"
            }
            if (l === "*info") {
                colorInfo.current = true;
                return "info"
            }
            return l
        })
        setShow(list1)
    }

    useImperativeHandle(ref, () => ({
        setHebrewText: (text1, phonetic1, info1) => {
            text.current = text1;
            phonetic.current = phonetic1;
            language.current = "hebrew";
            info.current = info1;
        },
        setFrenchText: (text1, info1=null) => {
            text.current = text1;
            phonetic.current = null;
            language.current = "french";
            info.current = info1;
        },

        // Argument s :
        // null --> invisible
        // [] --> text visible (everything else not visible)
        // combination of 'vowels', 'info', 'phonetic' --> what is visible (test is visible too)
        // if '*info', '*phonetic' and '*' --> info, phonetic, text are colored
        setShow: (s) => {setShowHandle(s);}
    }));

    return (
        <div className="text-box">
            <div className={"text "+(colorText.current ? "color" : "")} dir={language.current === "hebrew" ? "rtl" : "ltr"}>
                {!isTextVisible()
                    ? ("")
                    : ((language.current === 'french' || isVowelsVisible())
                        ? text.current
                        : removeNekudot(text.current)
                    )
                        .split('')
                        .map((char, i) =>
                            char === '▮'
                                ? (<span key={i} className={"missing-letter"}>?</span>)
                                : (<span key={i}>{char}</span>))
                }
            </div>
          {!isInfoVisible()
              ? null
              : <div className={"text-info "+(colorInfo.current ? "color" : "")} >
                  {info.current}
              </div>
          }
          {!isPhoneticVisible()
              ? null
              : <div className={"text-phonetic "+(colorPhonetic.current ? "color" : "")} >
                  {phonetic.current}
              </div>
          }
        </div>
    );
})

export default TextBox;